<template>
  <div>
  <ContentBox 
    title="询价项目"
    contentBj="#efefef"
    :footerShow="true"
    :leftShow="false">
    <slot>
      <div class="homeBox"> 
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-search
            style="margin-bottom: 10px;"
            v-model="search"
            placeholder="请输入搜索关键词"
            show-action
            @search="onSearch">
            <template #action>
              <div @click="onSearch">搜索</div>
            </template>
          </van-search>
          <van-list
            v-model="loading"
            :finished="finished"
            :error.sync="error"
            :finished-text="list.length ? '没有更多了' : '暂无数据'"
            @load="getList">
            <div v-for="item in list" :key="item.id" :style="{ backgroundColor: !item.isRead ? 'rgba(81,114,247,0.1)' : '#fff' }">
              <div class="itemBox">
                <div class="title">{{ item.title }} 
                  &nbsp;
                  <!--  -->
                  <van-tag v-if="item.projectStatus < 1 || !item.projectStatus" type="warning" round>未开始</van-tag>
                  <van-tag v-if="item.projectStatus == 1" type="success" round>进行中</van-tag>

                  <van-tag v-if="item.projectStatus >= 2" round>已结束</van-tag>
                  </div>
                <div class="orderCode">{{ item.orderCode }}</div>
                <div class="titleDesc">采购组织</div>
                <div class="contentText">{{ item.organizationName }}</div>

                <div class="doubleItem">
                  <div class="titleDesc">物料种类</div>
                  <div class="titleDesc">询价类别</div>
                </div>
                <div class="doubleItem">
                  <div class="contentText" style="color:cornflowerblue">{{ item.commodityCount }} 项</div>
                  <div class="contentText">{{ item.categoryName ? item.categoryName : '暂无' }}</div>
                </div>

                 <div class="doubleItem">
                  <div class="titleDesc">剩余时间</div>
                  <div class="titleDesc">开始时间</div>
                </div>
                <div class="doubleItem">
                  <div class="contentText" style="color:chartreuse;">{{ item.remainingTime }}</div>
                  <div class="contentText">{{ item.startTime }}</div>
                </div>

                 <div class="doubleItem">
                  <div class="titleDesc">我的报价</div>
                  <div class="titleDesc">我的排名</div>
                </div>
                <div class="doubleItem">
                  <div class="contentText">{{ item.quotationNum ? item.quotationNum : 0 }}/{{ item.quotationRound ? item.quotationRound : 0 }}次</div>
                  <div class="contentText">{{ item.rank ? item.rank : '暂无' }}</div>
                </div>

                <div class="remark" v-show="item.remark">备注：{{ item.remark ? item.remark : '暂无' }}</div>

                <div class="btns">
                  <van-button plain type="danger" size="small" block @click="onClickItem(item)">查看详情</van-button>
                  &nbsp;&nbsp;
                  <van-button @click="onOffer(item)" v-if="item.projectStatus == 1 && (item.quotationNum < item.quotationRound)" color="#ee5a52" size="small" block>立即报价</van-button>
                  <van-button disabled color="#8c8c8c" v-if="item.projectStatus < 1 || !item.projectStatus" type="info" size="small" block>未开始</van-button>
                  <van-button disabled color="#8c8c8c" v-if="item.projectStatus >= 2" type="info" size="small" block>已截止</van-button>
                </div>
              </div>
            </div>
          </van-list>
        </van-pull-refresh> 
      </div>
    </slot>
    <template #footer> 
      <FooterNav/>
    </template> 
  </ContentBox>
  <NewOffer  
    ref="NewOfferRef"
    :detailObj="detailObj"
    @submitSuccess="onRefresh"
  />
</div>
</template>

<script>  
import FooterNav from '@/components/Basic/FooterNav' 
import NewOffer from '@/views/enquiry/newOffer.vue';   
export default {
  name: 'message',
  components: { 
    FooterNav,
    NewOffer
  },
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      pageNum: 1,
      isInit: true,
      search: '',
      error: false,

      detailObj: {}
    }
  },
  activated() { 
    if(!this.isInit) { 
      this.onRefresh();
    }
  }, 
  created() {
    this.onRefresh();
  },
  methods: { 
    // 获取出货总览数据
    getList() {
      // 如果是刷新状态，重置数据
      if (this.refreshing) {
        this.list = [];
        this.pageNum = 1;
      }
      
      // 设置加载状态
      this.loading = true;
      // 清除错误状态
      this.error = false;
      
      return this.$http.get('/api/srm/app/inquiry/list', { 
        pageNum: this.pageNum,
        pageSize: 10,
        search: this.search
      }).then(({ data }) => {
        this.isInit = false
        let { list, total } = data;
        this.list = [...this.list, ...list];
         
        // 关闭加载状态
        this.loading = false;
        
        // 检查是否已经加载完所有数据
        if (this.list.length >= Number(total)) {
          this.finished = true;
        } else { 
          // 增加页码
          this.pageNum++;
        }
        
        // 如果是刷新操作，关闭刷新状态
        if (this.refreshing) {
          this.refreshing = false;
        } 
      }).catch((error) => {
        // 出错时也要关闭加载状态
        this.loading = false;
        this.refreshing = false;
        // 设置finished为true，防止继续尝试加载
        this.finished = true;
        // 设置错误状态
        this.error = true;
        console.error('获取消息列表失败:', error);
      });
    }, 
    onSearch() { 
      // 清空列表数据
      this.finished = false;
      this.list = [];
      this.isInit = true;
      this.pageNum = 1;
      this.getList();
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      this.list = [];
      // 重新加载数据
      this.pageNum = 1;
      // 将 loading 设置为 true，表示处于加载状态
      this.refreshing = true;
      return this.getList();
    },
    // 查看详情
    onClickItem(item) {
      this.$router.push({
        path: '/enquiry/enquiryDetail',
        query: {
          id: item.id
        }
      })
    },
    onOffer(item) {
      this.detailObj = item;
      this.$refs.NewOfferRef.show = true;
    }

  }
}
</script>

<style lang="less" scoped>
 // 整体容器样式
 .homeBox {
  margin: 8px;
  font-size: 0.48rem;
  
  // 搜索框容器优化
  :deep(.van-search) {
    background: linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%) !important;
    border-radius: 8px;
    padding: 6px 10px;
    box-shadow: 0 2px 8px rgba(255, 107, 107, 0.2);
    
    .van-search__content {
      background: rgba(255, 255, 255, 0.95);
      border-radius: 6px;
    }
    
    .van-search__action {
      color: #ff6b6b;
      font-weight: bold;
      padding: 0 12px;
      background: #fff;
      border-radius: 4px;
      margin-left: 6px;
      transition: all 0.3s;
      
      &:hover {
        background: #ff6b6b;
        color: #fff;
      }
    }
    
    input::placeholder {
      color: #999;
    }
  }
  
  // 询价项目卡片样式
   .itemBox { 
      padding: 10px;
      margin-bottom: 8px;
      background: #fff;
      border-radius: 10px;
      box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06);
      transition: all 0.3s ease;
      border: 1px solid rgba(255, 107, 107, 0.08);
      
      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(255, 107, 107, 0.15);
      }
      
      // 未读项目标识
      &[style*="rgba(81,114,247,0.1)"] {
        border-left: 3px solid #ff6b6b;
        background: linear-gradient(135deg, rgba(255, 107, 107, 0.05) 0%, #fff 100%);
      }
      
      // 标题样式
      .title { 
        display: flex;
        align-items: center;
        font-weight: bold;
        font-size: 0.5rem;
        color: #333;
        margin-bottom: 4px;
        
        // 状态标签优化
        :deep(.van-tag) {
          font-size: 0.3rem;
          padding: 2px 6px;
          margin-left: 6px;
        }
      }
      
      // 订单编号
      .orderCode { 
        padding: 4px 0;
        font-size: 0.38rem;
        color: #999;
        background: #f5f5f5;
        border-radius: 4px;
        padding: 6px 10px;
        margin-bottom: 6px;
        font-family: 'Courier New', monospace;
      }
      
      // 标题描述
      .titleDesc { 
        padding: 4px 0;
        font-size: 0.36rem;
        color: #888;
        font-weight: 500;
      }
      
      // 双列布局
      .doubleItem {
        display: flex;
        margin-bottom: 4px;
        >div { 
          flex: 1;
        }
      }
      
      // 内容文本
      .contentText { 
        padding-bottom: 4px;
        font-size: 0.42rem;
        font-weight: bold;
        color: #333;
        
        // 特殊颜色优化
        &[style*="cornflowerblue"] {
          color: #ff6b6b !important;
        }
        
        &[style*="chartreuse"] {
          color: #ff6b6b !important;
          font-size: 0.44rem;
        }
      }
      
      // 备注信息
      .remark { 
        font-size: 0.36rem;
        color: #999;
        padding: 6px;
        background: #f5f5f5;
        border-radius: 6px;
        margin: 6px 0;
        border-left: 2px solid #ff6b6b;
      }
      
      // 按钮组
      .btns { 
        display: flex;
        margin-top: 8px;
        gap: 8px;
        
        :deep(.van-button) {
          border-radius: 6px;
          font-weight: bold;
          transition: all 0.3s;
          
          &:not([disabled]):hover {
            transform: scale(1.02);
            box-shadow: 0 2px 8px rgba(255, 107, 107, 0.2);
          }
          
          // 查看详情按钮
          &[type="info"] {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            border: none;
            color: #fff;
            
            &:hover {
              background: linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%);
            }
          }
          
          // 立即报价按钮
          &[style*="type=\"info\""] {
            background: linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%);
            border: none;
            color: #fff;
            
            &:hover {
              background: linear-gradient(135deg, #ff5252 0%, #dd4b4b 100%);
            }
          }
          
          // 禁用状态
          &[disabled] {
            background: #e0e0e0;
            color: #999;
            border: none;
          }
        }
      }
   }
    
   // 加载完成提示
   :deep(.van-list__finished-text) {
     color: #999;
     font-size: 0.38rem;
     padding: 12px;
   }
   
   // 下拉刷新样式
   :deep(.van-pull-refresh) {
     overflow: visible;
   }
 }
</style>